import * as z from "zod/v4";

/**
 * Advanced flow attached to a shopper-agent trigger. When the trigger fires
 * and the shopper agent takes over, any attached automation with
 * `enabled !== false` is also dispatched alongside the marketing-agent
 * coordinator — so both paths run concurrently. When the shopper agent does
 * not take over, the normal advanced-flow dispatch already covers it.
 */
export const ShopperAgentAutomationConfigSchema = z.object({
  automationId: z.string(),
  enabled: z.boolean().optional(),
});

export type ShopperAgentAutomationConfig = z.infer<
  typeof ShopperAgentAutomationConfigSchema
>;
